module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAJCAYAAADkZNYtAAAAoklEQVR4AXTQvQ3CMBAF4GfjgiWQaKDiR6KhoEFCghGoiBiBBdglWKnYICEFE0RQ0tFlhRRxLk7SJNbZ0lX+np91EsxZHS/b9SGYu1csViRmI4XUDbA4e+moItzdAIub+k+iH25Abk4B+UYKhAAmtuE33V/HMou18E1JtAQoN6jO/3dYeL9hN7JQAokxdPvG0dM2gMUDmHbQi+3qdu2LPdjgGgAA//8npeksAAAABklEQVQDAM9IU3QgO/L0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/arrow1.png
// module id = gOVl
// module chunks = 2